import React from 'react';
import { Col } from '@cvent/carina/components/Col';
import { Row } from '@cvent/carina/components/Row';
import { useTheme } from '@cvent/carina/components/ThemeProvider';

type FormElementContainerProps = {
  testID: string;
  children: React.ReactNode;
};
export const FormElementContainer = ({ testID, children }: FormElementContainerProps): JSX.Element => {
  const { spacing } = useTheme();

  return (
    <Row justifyContent={'center'} testID={`${testID}_form_element_row`}>
      <Col
        padding={0}
        css={{ marginTop: spacing['4'], marginBottom: spacing['4'] }}
        testID={`${testID}_form_element__col`}
      >
        {children}
      </Col>
    </Row>
  );
};
